import React from 'react';
import OpIcon from 'components/Common/op-ui-wrappers/OpIcon/OpIcon';
import OpButton from 'components/Common/op-ui-wrappers/OpButton/OpButton';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import styles from './PlusReceiptsPage.module.scss';

const PlusReceiptsPage = () => {
  return (
    <div className={styles.container}>
      <div className={styles.backButton}>
        <OpIcon icon="arrow-left" />
        <OpText variant="title-small-regular">Back to plus membership dashboard</OpText>
      </div>
      <h1 className={styles.header}>Your Plus membership receipts</h1>
      <div className={styles.receipts}>
        <div className={styles.receipt}>
          <div className={styles.receiptHeader}>
            <OpText variant="body-large-bold">02 Feb 2023</OpText>
          </div>
          <div className={styles.receiptBody}>
            <div className={styles.receiptBodyItem}>
              <OpText block variant="title-small-bold">
                Total
              </OpText>
              <OpText block variant="title-small-regular">
                € 99.99
              </OpText>
            </div>
            <div className={styles.receiptBodyItem}>
              <OpText block variant="title-small-bold">
                Total
              </OpText>
              <OpText block variant="title-small-regular">
                € 99.99
              </OpText>
            </div>
          </div>
          <div className={styles.receiptAction}>
            <OpButton size="medium" variant="secondary">
              <OpText variant="body-medium-regular">See receipt</OpText>
            </OpButton>
          </div>
        </div>
        <div className={styles.receipt}>
          <div className={styles.receiptHeader}>
            <OpText variant="body-large-bold">02 Feb 2023</OpText>
          </div>
          <div className={styles.receiptBody}>
            <div className={styles.receiptBodyItem}>
              <OpText block variant="title-small-bold">
                Total
              </OpText>
              <OpText block variant="title-small-regular">
                € 99.99
              </OpText>
            </div>
            <div className={styles.receiptBodyItem}>
              <OpText block variant="title-small-bold">
                Total
              </OpText>
              <OpText block variant="title-small-regular">
                € 99.99
              </OpText>
            </div>
          </div>
          <div className={styles.receiptAction}>
            <OpButton size="medium" variant="secondary">
              <OpText variant="body-medium-regular">See receipt</OpText>
            </OpButton>
          </div>
        </div>
        <div className={styles.receipt}>
          <div className={styles.receiptHeader}>
            <OpText variant="body-large-bold">02 Feb 2023</OpText>
          </div>
          <div className={styles.receiptBody}>
            <div className={styles.receiptBodyItem}>
              <OpText block variant="title-small-bold">
                Total
              </OpText>
              <OpText block variant="title-small-regular">
                € 99.99
              </OpText>
            </div>
            <div className={styles.receiptBodyItem}>
              <OpText block variant="title-small-bold">
                Total
              </OpText>
              <OpText block variant="title-small-regular">
                € 99.99
              </OpText>
            </div>
          </div>
          <div className={styles.receiptAction}>
            <OpButton size="medium" variant="secondary">
              <OpText variant="body-medium-regular">See receipt</OpText>
            </OpButton>
          </div>
        </div>
        <div className={styles.receipt}>
          <div className={styles.receiptHeader}>
            <OpText variant="body-large-bold">02 Feb 2023</OpText>
          </div>
          <div className={styles.receiptBody}>
            <div className={styles.receiptBodyItem}>
              <OpText block variant="title-small-bold">
                Total
              </OpText>
              <OpText block variant="title-small-regular">
                € 99.99
              </OpText>
            </div>
            <div className={styles.receiptBodyItem}>
              <OpText block variant="title-small-bold">
                Total
              </OpText>
              <OpText block variant="title-small-regular">
                € 99.99
              </OpText>
            </div>
          </div>
          <div className={styles.receiptAction}>
            <OpButton size="medium" variant="secondary">
              <OpText variant="body-medium-regular">See receipt</OpText>
            </OpButton>
          </div>
        </div>
        <div className={styles.receipt}>
          <div className={styles.receiptHeader}>
            <OpText variant="body-large-bold">02 Feb 2023</OpText>
          </div>
          <div className={styles.receiptBody}>
            <div className={styles.receiptBodyItem}>
              <OpText block variant="title-small-bold">
                Total
              </OpText>
              <OpText block variant="title-small-regular">
                € 99.99
              </OpText>
            </div>
            <div className={styles.receiptBodyItem}>
              <OpText block variant="title-small-bold">
                Total
              </OpText>
              <OpText block variant="title-small-regular">
                € 99.99
              </OpText>
            </div>
          </div>
          <div className={styles.receiptAction}>
            <OpButton size="medium" variant="secondary">
              <OpText variant="body-medium-regular">See receipt</OpText>
            </OpButton>
          </div>
        </div>
        <div className={styles.receipt}>
          <div className={styles.receiptHeader}>
            <OpText variant="body-large-bold">02 Feb 2023</OpText>
          </div>
          <div className={styles.receiptBody}>
            <div className={styles.receiptBodyItem}>
              <OpText block variant="title-small-bold">
                Total
              </OpText>
              <OpText block variant="title-small-regular">
                € 99.99
              </OpText>
            </div>
            <div className={styles.receiptBodyItem}>
              <OpText block variant="title-small-bold">
                Total
              </OpText>
              <OpText block variant="title-small-regular">
                € 99.99
              </OpText>
            </div>
          </div>
          <div className={styles.receiptAction}>
            <OpButton size="medium" variant="secondary">
              <OpText variant="body-medium-regular">See receipt</OpText>
            </OpButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlusReceiptsPage;
